import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let DoublefieldComp;

class Doublefield extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: DoublefieldComp};
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/doublefield-comp" */
            "../../../components/javascript/zcat-components/doublefield-comp"
        ).then(function(res) {
            DoublefieldComp = res.DoublefieldComp;
        }));

        
;
    }
}

export {Doublefield};

